/** Padel USA preview integration. See features/premium-interface-preview.md.
 * No cart, product, messaging, analytics or network writer. */
(() => {
  if (!document.body.classList.contains('pusa-premium-preview')) return;
  // SSR already uses descriptive spans. Also normalize legacy linked fragments after
  // product/variant hydration, so stale markup cannot revive navigation or Tab stops.
  const productRoot = document.querySelector('#MainContent[data-template*="product"]');
  if (productRoot) {
    const makeLabelsStatic = () => {
      productRoot.querySelectorAll('a[class^="expert-fit-chip-"]').forEach((link) => {
        const label = document.createElement('span');
        label.className = link.className;
        label.textContent = link.textContent;
        link.replaceWith(label);
      });
    };
    let labelsQueued = false;
    new MutationObserver(() => {
      if (labelsQueued) return;
      labelsQueued = true;
      queueMicrotask(() => { labelsQueued = false; makeLabelsStatic(); });
    }).observe(productRoot, { childList: true, subtree: true });
    makeLabelsStatic();
  }
  // Default to the original title row. The optional image comparison needs roomy cards.
  const collectionRoot = document.querySelector('#MainContent[data-template*="collection"]');
  if (collectionRoot) {
    const imageComparison = new URLSearchParams(location.search).get('pusa_sale_layout') === 'image';
    const observedGalleries = new Set();
    const placeDeal = (card) => {
      if (!card) return;
      const media = card.querySelector('.card-gallery');
      const deal = card.querySelector('.collection-deal-row');
      const title = card.querySelector('[ref="productTitleLink"]');
      if (!media || !deal || !title) return;
      const stackedBadge = media.querySelector('.premium-card-promotions > .product-badges--promo');
      if (stackedBadge) media.append(stackedBadge);
      let promotions = media.querySelector('.premium-card-promotions');
      if (!sizeObserver || media.getBoundingClientRect().width <= 299) {
        if (deal.parentElement !== title) title.prepend(deal);
        if (promotions && !promotions.children.length) promotions.remove();
        return;
      }
      if (deal.parentElement === promotions) return;
      if (!promotions) {
        promotions = document.createElement('div');
        promotions.className = 'premium-card-promotions';
        media.append(promotions);
      }
      promotions.append(deal);
    };
    const sizeObserver = imageComparison && typeof ResizeObserver === 'function' ? new ResizeObserver((entries) => {
      entries.forEach(({ target }) => {
        if (target.isConnected) placeDeal(target.closest('product-card'));
      });
    }) : null;
    const syncCards = () => {
      collectionRoot.querySelectorAll('product-card').forEach((card) => {
        placeDeal(card);
        const media = card.querySelector('.card-gallery');
        if (sizeObserver && media && card.querySelector('.collection-deal-row') && !observedGalleries.has(media)) {
          observedGalleries.add(media);
          sizeObserver.observe(media);
        }
      });
      observedGalleries.forEach((media) => {
        if (media.isConnected) return;
        sizeObserver.unobserve(media);
        observedGalleries.delete(media);
      });
    };
    let cardsQueued = false;
    new MutationObserver(() => {
      if (cardsQueued) return;
      cardsQueued = true;
      queueMicrotask(() => { cardsQueued = false; syncCards(); });
    }).observe(collectionRoot, { childList: true, subtree: true });
    syncCards();
  }
  let queued = false;
  const sync = () => {
    queued = false;
    const container = document.querySelector('.shop-ai-chat-container');
    const bubble = container?.querySelector('.shop-ai-chat-bubble');
    const panel = container?.querySelector('.shop-ai-chat-window');
    if (!container || !bubble || !panel) return;
    const overlay = Boolean(document.querySelector('dialog[open], #Details-menu-drawer-container[open]') ||
      ('popover' in HTMLElement.prototype && document.querySelector('.bbc-pop:popover-open')));
    container.inert = overlay;
    const closed = getComputedStyle(panel).pointerEvents === 'none';
    const ownedFocus = panel.contains(document.activeElement);
    panel.inert = closed || overlay;
    panel.setAttribute('aria-hidden', String(closed || overlay));
    bubble.setAttribute('aria-expanded', String(!closed));
    if (!bubble.dataset.premiumKeyboard) {
      bubble.dataset.premiumKeyboard = 'true';
      bubble.tabIndex = 0;
      bubble.setAttribute('role', 'button');
      bubble.setAttribute('aria-label', 'Chat with a padel expert');
      bubble.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        bubble.click();
      });
    }
    if (closed && ownedFocus && !overlay) bubble.focus({ preventScroll: true });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(sync);
  };
  new MutationObserver(schedule).observe(document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['class', 'style', 'open'],
  });
  // Native popover state is a pseudo-class rather than an observed open attribute.
  document.addEventListener('toggle', schedule, true);
  sync();
})();
